export default "__VITE_ASSET__2849cb8b__"